import axios from "axios";
import { Component } from "react";
import { connect } from "react-redux";
import urls from "../../urls";
// import StoreTableRow from "./itemsTr";
import { showSuccess, showError } from "../../utils";
import formatDateArabicDZ from "../../utils/formatDate";
import {
  setInvoiceInitialData,
  setinvoiceIsLoading,
} from "../../redux-state/features/invoiceSlice/invoiceSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../shared-components/pagination";
class InvoiceTable extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      currentPage: 1,
      totalPages: 0,
    };
    this.headerText = [
      "#",
      "رقم الفاتورة",
      "الموّرد",
      "التاريخ",
      "عرض تفاصيل الفاتورة ",
    ];
  }
  componentDidMount() {
    this.fetchInvoices();
  }
  fetchInvoices = (page = 1, limit = 10) => {
    this.props.setinvoiceIsLoading(true);
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));

    axios
      .get(urls.getAllInvoices, {
        params: { page, limit, faculty_id }, // Sending pagination parameters
      })
      .then((res) => {
        const { table_data, total } = res.data;
        const invoices = table_data || [];

        this.props.setInvoiceInitialData(invoices);
        this.setState({
          totalPages: total,
          currentPage: page,
          pageSize: limit,
        });
      })
      .catch((err) => {
        console.error("Error fetching invoices:", err);
      })
      .finally(() => {
        this.props.setinvoiceIsLoading(false);
      });
  };

  handleDeleteItem = (uuid) => {
    // this.setState((prevState) => ({
    //   table_data: prevState.table_data.filter((item) => item.uiid !== uuid),
    // }));
    axios
      .delete(urls.deleteItemFromStore, {
        data: { uuid: uuid }, // Send the UUID in the request body
      })
      .then((response) => {
        // Handle success
        const msg = "تم حذف العنصر بنجاح ";
        showSuccess(msg); // Show success message
        // this.props.deleteItem({ uuid });
        // Remove the item from the state
        // this.setState((prevState) => ({
        //   table_data: prevState.table_data.filter((item) => item.uiid !== uuid),
        // }));
      })
      .catch((err) => {
        // Handle error
        const errorMsg = "لم يتم الحذف بنجاح ";

        showError(errorMsg); // Show error message
      });
  };
  viewInvoiceDetails = (invoice_id) => {
    console.log(invoice_id);
  };
  // Handle page change function
  handlePageChange = (newPage) => {
    this.fetchInvoices(newPage);

    // Implement logic to update table data based on the new page
  };
  render() {
    const { table_data, loading, showPagination } = this.props;
    const { currentPage, totalPages } = this.state;
    return (
      <div>
        <div className="d-flex justify-content-end">
          {showPagination && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={this.handlePageChange}
            />
          )}
        </div>
        <table className="table align-middle table-hover">
          <thead className="table-light text-center">
            <tr style={{ fontSize: "12px" }}>
              {this.headerText.map((txt, idx) => (
                <th scope="col" key={"strore-table" + idx}>
                  {txt}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="text-center">
                  <div
                    className="spinner-border text-primary"
                    style={{ width: "3rem", height: "3rem" }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : (
              table_data.map((obj, idx) => {
                return (
                  <tr
                    className="text-center"
                    style={{ fontSize: "13px", width: "30px" }}
                  >
                    <td style={{ width: "5%" }}>{idx + 1}</td>
                    <td
                      style={{ width: "20%" }}
                    >{`${obj.invoice_year}/${obj.invoice_id}`}</td>
                    <td style={{ width: "20%" }}>{obj.supplier_name}</td>
                    <td style={{ width: "30%" }}>
                      {formatDateArabicDZ(obj.invoice_date).replace(
                        " في ",
                        "  على الساعة "
                      )}
                    </td>
                    <td>
                      <button
                        className="btn border border-1"
                        onClick={() => {
                          const invoiceNumber = `${obj.invoice_year}/${obj.invoice_id}`;

                          this.props.onInvoiceDetails(
                            obj.invoice_id,
                            obj.supplier_name,
                            invoiceNumber,
                            formatDateArabicDZ(obj.invoice_date).replace(
                              " في ",
                              "  على الساعة "
                            ),
                            obj.supplier_id
                          );
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faEye}
                          title="عرض تفاصيل الفاتورة "
                          size="lg"
                        />
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setInvoiceInitialData,
  setinvoiceIsLoading,
};
const mapStateToProps = (state) => ({
  table_data: state.invoiceState.data,
  loading: state.invoiceState.isLoading,
  userType: state.userState.userType,
});
export default connect(mapStateToProps, mapDispatchToProps)(InvoiceTable);
